import {FormsData} from 'contexts/FormsDataContext';
import {Form as FormItem} from '@yandex-data-ui/cloud-schemas/build/models/ui-api';

export enum ModalFormType {
    Preview = 'preview-form',
    ContactSales = 'contact-form',
    Interconnect = 'interconnect-form',
    PartnerCommunication = 'partner-communication',
    Form = 'form',
}

export const parseFormHash = (
    hash?: string,
    formsData?: FormsData,
): {type: ModalFormType | null; param?: string; formData?: FormItem | null} => {
    if (!hash) {
        return {type: null};
    }

    const [type, param] = hash.split(':');
    let modalFormType = null;
    let formData = null;

    if (
        Object.values(ModalFormType).includes(type as ModalFormType) &&
        type !== ModalFormType.Form
    ) {
        modalFormType = type as ModalFormType;
    } else if (formsData) {
        formData = formsData[type];

        if (formData) {
            modalFormType = ModalFormType.Form;
        }
    }

    return {type: modalFormType, param, formData};
};

export function getFormType(hash?: string) {
    if (!hash) {
        return null;
    }

    return Object.values(ModalFormType).includes(hash as ModalFormType)
        ? (hash as ModalFormType)
        : null;
}
